// redux/slices/counterSlice.js
import { createSlice } from "@reduxjs/toolkit";
import { employeeReducer } from "../Reducer/employeeReducer";

const initialState = {

    loading: false,
    employees: [],
    directoryUsers: [],
    directoryLoading: false,
    error: null,
    isDataUpdated: false,
    pagination: {
        totalData: 10,
        currentPage: 1,
        pageSize: 10,
        totalPages: 1
    }
};

const employeeSlice = createSlice({
    name: "employee",
    initialState,
    reducers: {
        setEmployeePagination: (state, action) => {
            state.pagination = action.payload
        }
    },
    extraReducers: (builder) => {
        employeeReducer(builder);
    },
});

export const { setEmployeePagination } = employeeSlice.actions;
export default employeeSlice.reducer;
